import request from '@/utils/request'

export function getLogList(data) {
  return request({ url: '/admin/operation-log/list', method: 'post', data })
}

export function clearLogs() {
  return request({ url: '/admin/operation-log/clear', method: 'post', data: {} })
}

export function getLogModules() {
  return request({ url: '/admin/operation-log/modules', method: 'post', data: {} })
}
